import { render, staticRenderFns } from "./eligible_products.vue?vue&type=template&id=50af2e92&scoped=true"
import script from "./eligible_products.vue?vue&type=script&lang=js"
export * from "./eligible_products.vue?vue&type=script&lang=js"
import style0 from "./eligible_products.vue?vue&type=style&index=0&id=50af2e92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50af2e92",
  null
  
)

export default component.exports